export const DESTROY = 'destroy';
export const LOAD    = 'load';
export const READY   = 'ready';
export const ERROR   = 'error';


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/core/kakaotv-url-player/events.js
 **/